import "./utils/whyDidYouRender";
// IMPORTANT: the whyDidYouRender import must be very first

import React from "react";
import objectFitImages from "object-fit-images";
import { createRoot } from "react-dom/client";

import "url-search-params-polyfill";
import Root from "components/Root";
import { initDatadogRUM } from "services/datadog";
import detectFontAwesome from "services/detectFontAwesome";
import { wrap as reportErrors } from "services/errorReporter";
import { configVault } from "services/sensitiveData";
import zoningApi from "services/zoningApi";

require("normalize.css");
require("./sharedStyles/global.scss");
require("./fonts/index.pure.css");

const startApp = () => {
  const rootEl = document.getElementById("container");
  const configurationEl = document.getElementById("configuration");

  const {
    initialState,
    fixedGuideId,
    locale,
    featureFlags,
    deliveryStage,
    mode,

    datadog,
    vault,
    google_maps: { token: googleMapsKey },
    mapbox: { token: mapboxToken },
    pusher: pusherConfig,
  } = JSON.parse(configurationEl.innerHTML);

  if (datadog) initDatadogRUM(datadog);
  if (vault) configVault(vault);

  const configVariables = {
    googleMapsKey,
    mapboxToken,
    deliveryStage,
    mode,
    fixedGuideId,
  };

  detectFontAwesome();

  zoningApi.configure({
    baseURL: window.location.protocol + "//" + window.location.host,
    locale,
    version: initialState.tenant.versionNumber,
  });

  const root = createRoot(rootEl);
  root.render(
    <Root
      locale={locale}
      featureFlags={featureFlags}
      pusherConfig={pusherConfig}
      configVariables={configVariables}
      tenantMetadata={initialState.tenant}
    />,
  );
};

// Polyfill object-fit/object-position on <img>: IE9, IE10, IE11, Edge, Safari, ...
objectFitImages();

reportErrors(startApp, { component: "startApp" })();
